import styled from 'styled-components';
import colors from '_colors.module.scss';

export const MarkdownContent = styled.div`
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;

  border: 1px solid ${colors.Border1};
  border-radius: 8px;
`;
